<script>
	// Logic
	import { afterUpdate, onMount } from "svelte";
	import { allKommunesData } from "../utils/apiStore";

	//Components
	import RegSmitteCard from "../components/cards/RegSmitteCard.svelte";
	import KommuneList from "../components/KommuneList.svelte";

	// Bindings
	export let kommunenavn;
	$: kData = undefined;
	// $: kInfo = kommuneinfo(kommunenavn);
	const antallChart1 = 45;
	$: error = false;
	export const route = {};

	onMount(() => {});

	afterUpdate(() => {
		window.scrollTo(0, 0);
		if (!kData || kData.name !== kommunenavn) {
			allKommunesData.subscribe((res) => {
				if (res != undefined) {
					kData = res.find((muni) => muni.name == kommunenavn);
					error = false;
					if (!kData) {
						error = true;
					}
				}
			});
		}
	});
</script>

<div class="page-content-section">
	<div class="page-content wide mt-0">
		<a class="page-content__btn-text" href="#/">Tilbake til oversikten</a>
		{#if !error}
			<h1 class="page-content__title mt-1">Nøkkeltall for {kommunenavn}</h1>
		{/if}

		{#if kData}
			<div class="container">
				<div class="columns mt-0">
					<div class="column col-12 mt-0">
						<RegSmitteCard
							title="Registrert smitte"
							subtitle="Hva viser grafen?"
							poptext={"Den røde linjen viser snittet de siste 7 dager. Søylene viser antall tilfeller pr dag."}
							p2={kData.totalt}
							switchgraph={true}
							{antallChart1}
							chartData={kData.all.slice(-antallChart1)}
							chartData2={kData.all}
						/>
					</div>
				</div>
			</div>
		{:else if error}
			<p>
				Vi klarer ikke finne kommunen <b>{kommunenavn}</b>... <br />Prøv en
				annen fra listen nedenfor👇🏼
			</p>
		{/if}
		<!-- {#if !error}
          {#await kInfo then kInfo}
            <a class="kommune-link-content" href={kInfo.url}> <Link/> <p class="kommune-link">Se kommunens hjemmeside for mer informasjon.</p></a>
          {/await}
        {/if} -->
	</div>
	<div class="page-content">
		<h1 class="page-content__title">Kommuneoversikt</h1>
		<p class="page-content__ingress">Velg kommune for å se hele utviklingen.</p>
		<!-- <KommuneTable/> -->
		<KommuneList />
	</div>
</div>

<style lang="scss">
	.kommune-link-content {
		display: flex;
		margin: 1rem 0;
		.kommune-link {
			margin: 0;
			margin-left: 0.3rem;
			font-size: fontsize("std");
		}
	}

	.smitte-notis {
		margin: 0;
		margin-bottom: 0.5rem;
		font-size: fontsize("md");
	}
</style>
